import { render, staticRenderFns } from "./PersonGenrateTextResult.vue?vue&type=template&id=c0602c20&"
import script from "./PersonGenrateTextResult.vue?vue&type=script&lang=js&"
export * from "./PersonGenrateTextResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports